import React from 'react';
import classnames from 'classnames';
import Icon from './icon';

export default function ButtonRound(props) {

    const {className, type='primary', active=false, size='m', icon='plus', onClick=null, ...restprops } = props;

    const classname = classnames('btn-round', `btn-${type}`, `btn-size-${size}`, className, {active});

    return (
        <button type="button" onClick={(e, ...args) => { if(onClick) { e.preventDefault(); e.stopPropagation(); onClick(e, ...args)}}} {...restprops} className={classname}>
            <Icon  icon={icon} size={size}/>
        </button>
    );
}



// WEBPACK FOOTER //
// ./src/js/components/button-round.js